import { render, staticRenderFns } from "./MultiCheckboxes.vue?vue&type=template&id=154b8e28&"
import script from "./MultiCheckboxes.vue?vue&type=script&lang=js&"
export * from "./MultiCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./MultiCheckboxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports